// extracted by mini-css-extract-plugin
export default {"wrapper":"Q_MyCapsulePlaceholder_wrapper__LS7WV"};